import { Box } from '@chakra-ui/react';
import { CheckCircleFilled } from 'components/icons/CheckCircleFilled';
import { EmptyCircle } from 'components/icons/EmptyCircle';
import { HalfFilledCircle } from 'components/icons/HalfFilledCircle';

const successIconStyle = {
  'svg *': {
    fill: '#389b07',
  },
};

const iconStyle = {
  'svg *': {
    fill: '#80bc9d',
  },
};

type TStatusIconProps = {
  isComplete: boolean;
  hasPriorEvents: boolean;
};

const StatusIcon = ({ isComplete, hasPriorEvents }: TStatusIconProps) => {
  if (isComplete) {
    return (
      <Box as="span" sx={successIconStyle}>
        <CheckCircleFilled height="20px" />
      </Box>
    );
  }
  if (hasPriorEvents) {
    return (
      <Box as="span" sx={iconStyle}>
        <HalfFilledCircle height="20px" />
      </Box>
    );
  }

  return (
    <Box as="span" sx={iconStyle}>
      <EmptyCircle height="20px" />
    </Box>
  );
};

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
};

const iconContainerStyle = {
  marginRight: (theme: any) => theme.space.four,
};

const textStyle = {
  textTransform: 'capitalize',
  fontSize: '13px',
  fontWeight: '600',
};

type TStatusSummaryProps = {
  isComplete?: boolean;
  status: string;
  hasPriorEvents?: boolean;
};

const StatusSummary = ({
  status,
  isComplete = false,
  hasPriorEvents = false,
}: TStatusSummaryProps) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={iconContainerStyle}>
        <StatusIcon isComplete={isComplete} hasPriorEvents={hasPriorEvents} />
      </Box>
      <Box as="span" sx={textStyle}>
        {status}
      </Box>
    </Box>
  );
};

export default StatusSummary;
